import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ObjectData } from '../../models/object-data';
import { MatDialog } from '@angular/material/dialog';
import {
  CATEGORIES,
  ManagementDialogComponent,
} from '../management-dialog/management-dialog.component';
import { ManagementService } from '../../services/management.service';
import { ObjectService } from '../../services/object.service';
import { Router } from '@angular/router';
import { ObjectManagement } from '../../models/object-management';
import { environment } from '../../../environments/environment';
import { PaymentService } from '../../services/payment.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Clipboard } from '@angular/cdk/clipboard';
import { ModalComponent } from '../modal/modal.component';
import { PatternDialogComponent } from '../pattern-dialog/pattern-dialog.component';
import { NotificationService } from '../../services/notification.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalConfirmService } from '../../services/modal-confirm.service';
import { ModalPaymentService } from '../../services/modal-payment.service';
import { WINDOW } from '../../window';

@Component({
  selector: 'app-management-table',
  styleUrl: './management-table.component.scss',
  templateUrl: './management-table.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    TooltipModule,
  ],
})
export class ManagementTableComponent implements OnInit, AfterViewInit {
  objects: ObjectManagement[] = [
    // {
    //   uuid: '955En',
    //   name: '2 1 3',
    //   language: 'ru',
    //   categoryId: 1,
    //   published: false,
    //   description: '<p>test</p>',
    //   latitude: null,
    //   longitude: null,
    //   paymentDetails: null,
    //   approved: false,
    //   expirationDate: null,
    //   created_at: new Date('2025-07-03T01:26:47.686+00:00'),
    //   updated_at: new Date('2025-07-03T01:26:47.671+00:00'),
    //   subscriptionLevel: 1,
    // },
    // {
    //   uuid: '955En',
    //   name: '2 1 3',
    //   language: 'ru',
    //   categoryId: 1,
    //   published: false,
    //   description: '<p>test</p>',
    //   latitude: null,
    //   longitude: null,
    //   paymentDetails: null,
    //   approved: false,
    //   expirationDate: null,
    //   created_at: new Date('2025-07-03T01:26:47.686+00:00'),
    //   updated_at: new Date('2025-07-03T01:26:47.671+00:00'),
    //   subscriptionLevel: 1,
    // },
  ];
  filteredObjects: ObjectManagement[] = [];
  frontendUrl = environment.frontendUrl;

  displayedColumns: string[] = [
    'uuid',
    'name',
    'language',
    'category',
    'public',
    'description',
    'action',
  ];

  categories = CATEGORIES;

  categoriesFilter: (string | number)[] = ['Все', 1, 2, 3];
  mode: string[] = ['Публичный', 'Приватный'];
  languages: string[] = ['Все', 'ru', 'by'];

  searchValue: string = '';

  selectedCategory: string | number = this.categoriesFilter[0];
  selectedLanguage: string = this.languages[0];

  dataSource: MatTableDataSource<ObjectManagement> = new MatTableDataSource<ObjectManagement>([]);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('input') input: ElementRef;

  constructor(
    private paginatorIntl: MatPaginatorIntl,
    public dialog: MatDialog,
    private managementService: ManagementService,
    private objectService: ObjectService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private notification: NotificationService,
    private paymentService: PaymentService,
    private clipboard: Clipboard,
    private modalConfirmService: ModalConfirmService,
    private modalPaymentService: ModalPaymentService,
    @Inject(WINDOW)
    private win: Window | null
  ) {
  }

  ngOnInit(): void {
    this.paginatorChanges();
    this.dataSource = new MatTableDataSource(this.filteredObjects);
    this.getObjects();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.applyFilters();
  }

  paginatorChanges(){
    this.paginatorIntl.itemsPerPageLabel = 'Строк:';
    this.paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 из ${length}`;
      }
      const startIndex = page * pageSize;
      const endIndex = Math.min(startIndex + pageSize, length);
      return `${startIndex + 1}–${endIndex} из ${length}`;
    };
    this.paginatorIntl.changes.next();
  }

  getObjects() {
    this.managementService.getAllObjects().subscribe(
      (objects: ObjectManagement[]) => {
        this.updateObjectsAndFilteredObjects(objects);
      },
      (error) => {
        this.router.navigate(['login']);
      }
    );
  }

  refreshTable() {
    this.managementService
      .getAllObjects()
      .subscribe((objects: ObjectManagement[]) => {
        this.updateObjectsAndFilteredObjects(objects);
      });
  }

  updateObjectsAndFilteredObjects(objects: ObjectManagement[]) {
    // Нормализуем строки дат в Date, чтобы соответствовать интерфейсу
    const normalized = objects.map((o) => ({
      ...o,
      createdAt:
        o.createdAt instanceof Date ? o.createdAt : new Date(o.createdAt),
      updatedAt:
        o.updatedAt instanceof Date ? o.updatedAt : new Date(o.updatedAt),
    }));

    // Сортировка по updatedAt по убыванию
    const sorted = normalized.sort(
      (a, b) => b.updatedAt.getTime() - a.updatedAt.getTime()
    );

    this.objects.splice(0, this.objects.length, ...sorted);
    this.filteredObjects.splice(0, this.filteredObjects.length, ...sorted);

    this.dataSource.data = this.filteredObjects;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyCategoryFilter() {
    const users: ObjectManagement[] = this.objects.filter(
      (user) => user.categoryId == this.selectedCategory
    );
    this.filteredObjects.splice(0, this.filteredObjects.length);
    this.filteredObjects.push(...users);
  }

  applyLanguageFilter() {
    this.filteredObjects = this.filteredObjects.filter((object) => {
      return object.language === this.selectedLanguage;
    });
  }

  applyFilters(event?: Event) {
    this.filteredObjects.splice(0, this.filteredObjects.length);
    this.filteredObjects.push(...this.objects);

    if (this.selectedCategory !== this.categoriesFilter[0]) {
      this.applyCategoryFilter();
    }

    if (this.selectedLanguage !== this.languages[0]) {
      this.applyLanguageFilter();
    }

    if (this.input.nativeElement.value !== '') {
      this.dataSource.filter = this.input.nativeElement.value
        .trim()
        .toLowerCase();
    }
    if (event) {
      this.searchValue = (event.target as HTMLInputElement).value;
    }
    this.dataSource.filter = this.searchValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  updateObject(objectData: ObjectManagement) {
    const dialogRef = this.dialog.open(ManagementDialogComponent, {
      data: { object: objectData, mode: 'update' },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.managementService
          .updateObject(result.object, objectData.uuid)
          .subscribe((object: ObjectManagement) => {
            this.refreshTable();
            for (let file of result.files) {
              if (typeof file !== 'string') {
                this.managementService
                  .uploadFiles(file, object.uuid)
                  .subscribe((filesResult) => {});
              }
            }
          });
      }
    });
  }

  addData() {
    const dialogRef = this.dialog.open(ManagementDialogComponent, {
      data: { object: null, mode: 'create' },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.managementService
          .createObject(result.object)
          .subscribe((object: ObjectManagement) => {
            this.refreshTable();
            for (let file of result.files) {
              this.managementService
                .uploadFiles(file, object.uuid)
                .subscribe((filesResult) => {});
            }
          });
      }
    });
  }

  removeData(row: ObjectManagement): void {
    const message = `Вы действительно хотите удалить объект "${row.name}" ${row.uuid}`;
    this.modalConfirmService
      .open({
        title: message,
        objectData: row,
        mode: 'warning',
        functionality: true,
        returnFunctionality: false
      })
      .subscribe((confirmed) => {
        if (confirmed) {
          this.managementService.deleteObject(row).subscribe(() => {
            this.refreshTable();
            this.notification.show(
              `Запись ${row.name} удалена`,
              'success',
              5000
            );
          });
        }
      });
  }

  sendQR(object: ObjectManagement) {
    const data = {
      name: object.name,
      objectUuid: object.uuid,
      url: `${this.document.location.protocol}//${this.document.location.hostname}/p/${object.uuid}`,
    };
    this.objectService.sendQrCode(data).subscribe((res) => {});
  }

  navigateToObject(event: MouseEvent, object: ObjectManagement) {
    const link = `${this.frontendUrl}/p/${object.uuid}`;
    if (event.ctrlKey || event.button === 1) {
      this.win.open(link, '_blank');
    } else {
      this.router.navigate(['p', object.uuid]);
    }
  }

  getCategoryName(categoryId: number): string {
    const category = CATEGORIES.find((c) => c.id === categoryId);
    return category ? category.name : 'N/A';
  }

  displayEditObjectLink(object: ObjectManagement) {
    this.managementService.generateTemporaryAccess(object).subscribe(
      (res) => {
        const link = `${this.frontendUrl}/p/${object.uuid}/edit`;
        this.clipboard.copy(link);
        this.notification.show(`Ссылка скопирована в буфер обмена!`, 'success');

        // Проверка нажатия Ctrl + Click
        // if (event.ctrlKey) {
        //   window.open(link, '_blank');
        // }
      },
      (error: HttpErrorResponse) => {
        if (object.published) {
          this.notification.show(
            `Невозможно сгенерировать ссылку на объект, поскольку объект уже опубликован`,
            'warning'
          );
        } else {
          this.notification.show(`Произошла ошибка!`, 'error');
        }
      }
    );
  }

  displayPaymentLink(object: ObjectManagement) {
    const desc = `Введите сумму для оплаты объекта ${object.name} (ID ${object.uuid})`;

    this.modalPaymentService
      .open({
        title: 'Введите сумму',
        description: desc,
        objectData: object,
        inputValue: '350',
      })
      .subscribe((amount) => {
        if (amount != null) {
          this.paymentService.getPaymentLink(object.uuid, amount).subscribe(
            (link: string) => {
              this.clipboard.copy(link);
              this.notification.show(
                `Ссылка скопирована в буфер обмена!`,
                'success'
              );
            },
            (error: HttpErrorResponse) => {
              this.notification.show(
                `Произошла ошибка ${error.status}`,
                'error'
              );
            }
          );
        }
      });
  }
}
